import { CheckoutPaths } from '@telialt/models/src/EshopModel';

export const PLAN_ORDERING_TEST_ID = {
    ORDER_SELECTION_MODAL: 'order-selection-modal',
    ORDER_RADIO_GROUP: 'plan-order-radio-group',
    ORDER_MODAL_CONTINUE: 'plan-order-modal-continue',
    ORDER_MODAL_CANCEL: 'plan-order-modal-cancel',
    ORDER_LEAD_MODAL: 'plan-order-lead-modal',
};

export const PLAN_ORDER_OPTION = { PROLONGATION: 'prolongation', NEW_CONTRACT: 'newContract' } as const;

export const PARAM_SERVICE_UO_ID_QUERY = 'serviceUoId';
export const PARAM_SERVICE_SO_ID_QUERY = 'serviceSoId';
export const PARAM_SERVICE_TYPE_QUERY = 'type';
export const PARAM_GIFTS_QUERY = 'gifts';
export const PARAM_DISNEY_QUERY = 'disney';
export const PARAM_NETFLIX_QUERY = 'netflix';
export const MODEM_SELECTION_URL = `/{segmentSlug}/internetas/ar-reikalingas-modemas`;
export const CHECKOUT_URL = `/{segmentSlug}/prekes/uzsakymas${CheckoutPaths.ClientData}`;
export const CONTRACT_PROLONGATION_LINK = '/mano/{segmentSlug}/paslaugos/keisti-plana';
export const DISNEY_VAS_OPTION_KEY = 'DISNEY_PLAN';
